import React from 'react';
import { SWRConfig } from 'swr';

import { axiosInstance } from './assets/utils/axiosInstance';
import { LanguageProvider as SafeLanguageProvider } from './components/LanguageSelect';
import { AuthProvider } from './contexts/auth/authContext';
import FingerprintProvider from './contexts/fingerprint/fingerprintContext';
import LanguageProvider from './contexts/lang/languageContext';
import { PartnerContext } from './contexts/partner/partnerContext';
import TimezoneProvider from './contexts/timezone/timezoneContext';
import { ToastNotificationContext } from './hooks/global/alert/useToastNotification';
import { ThemeProvider } from './utils/theme';

const fetcher = (url: string): Promise<unknown> =>
  axiosInstance()
    .get(url)
    .then((res) => res.data);

export default function Providers({ children }: Readonly<{ children: React.ReactNode }>) {
  if (import.meta.env.VITE_MAINTENANCE_MODE === 'true') {
    return (
      <LanguageProvider>
        <ThemeProvider>{children}</ThemeProvider>
      </LanguageProvider>
    );
  }

  return (
    <ThemeProvider>
      <SWRConfig
        value={{
          fetcher,
          errorRetryCount: 3,
        }}
      >
        <FingerprintProvider>
          <AuthProvider>
            <PartnerContext>
              <ToastNotificationContext>
                <SafeLanguageProvider>
                  <LanguageProvider>
                    <TimezoneProvider>{children}</TimezoneProvider>
                  </LanguageProvider>
                </SafeLanguageProvider>
              </ToastNotificationContext>
            </PartnerContext>
          </AuthProvider>
        </FingerprintProvider>
      </SWRConfig>
    </ThemeProvider>
  );
}
